import { NotificationSettingsInterface } from 'modules/profile/notification-settings/types/notification-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const NOTIFICATION_SETTINGS_API = '/api/dashboard/settings/notifications'

export function useNotificationSettings() {
  const { user, isWorkspaceOwner } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, NotificationSettingsInterface>({
    method: RequestMethodsEnum.get,
  })

  const isAllowed = isWorkspaceOwner

  const swrData = useSWR<NotificationSettingsInterface>(() => {
    if (user && isAllowed) {
      return NOTIFICATION_SETTINGS_API
    }
  }, fetcher)

  return {...swrData, isAllowed}
}
